import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubTable = async (pub_id, event_uuid, time, male, female) => {
    const { data } = await API.post(`/api/v1/rbzo/pubs/table/getAvailableTables`, {
        pubId: pub_id,
        eventUuid: event_uuid,
        time,
        male,
        female,
    });
    return data;
};
export const useTables = (pub_id, event_uuid, time, male, female) => {
    return useQuery(["pub_tables", pub_id, event_uuid, time, male, female], () => getPubTable(pub_id, event_uuid, time, male, female), {
        enabled: !!pub_id && !!event_uuid && !!time,
    });
};
